'use client'

import { useState, type SyntheticEvent } from 'react'
import { TYPICAL_ASPECT, logoBox, type LogoSize, type LogoSurface } from './logo-size'

/**
 * The style that draws a logo at its size (./logo-size.ts), from the shape the browser reads off the file once it has loaded. Until
 * then it is drawn as a typical wordmark, which most logos are, so the header barely moves when the real shape arrives. A shape read
 * for one address is not used for another: a workspace switch or a new upload starts again.
 */
export function useLogoBox(src: string | null, size: LogoSize, surface: LogoSurface, whiteOnDark = false) {
  const [read, setRead] = useState<{ src: string; aspect: number } | null>(null)
  const aspect = read && read.src === src ? read.aspect : TYPICAL_ASPECT
  const { height, maxWidth } = logoBox(size, aspect, surface, whiteOnDark)
  const onLoad = (event: SyntheticEvent<HTMLImageElement>) => {
    const { naturalWidth, naturalHeight } = event.currentTarget
    if (src && naturalWidth > 0 && naturalHeight > 0) setRead({ src, aspect: naturalWidth / naturalHeight })
  }
  return { style: { height: `${height}px`, maxWidth: `${maxWidth}px` }, onLoad }
}
